
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import RequestLogsForm from '@/services/WebsiteLog/forms/RequestLogsForm';
import { Website } from '@/services/Website/interfaces';

@Component({
  mixins: [Themeable],
})
export default class DeleteWebsiteDialog extends Vue {
  @Prop() public website!: Website;

  public visible: boolean = true;

  public deleteWebsite(): void {
    this.$emit('deleteWebsite', this.website);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
